import { components, OptionProps, GroupBase } from "react-select";
import classNames from "classnames";

type OptionOverrideProps<OptionType> = OptionProps<OptionType, false, GroupBase<OptionType>> & {
	stableClassName?: string;
};

const Option = <OptionType,>({
	children,
	stableClassName,
	...props
}: OptionOverrideProps<OptionType>) => (
	<components.Option
		className={classNames("react-select-field-option", stableClassName)}
		{...props}
	>
		{children}
	</components.Option>
);

export { Option };
